import { FreyrData } from '../types/Freyr';

export default (data: FreyrData): void => {
  window.freyr = window.freyr ? window.freyr : { cmd: [] };
  window.freyr.cmd.push(() => window.freyr.pushAndUpdate('hawkEvent', data));
};
